import { managerActions } from '@store/reducers/manager/actions'
import { all, put } from 'redux-saga/effects'

import { InitEmptyProjectActions } from './initProjectActions'

export function* initEmptyProjectActionsSaga() {
  try {
    yield put({ type: managerActions.resetProject.type })

    yield all(InitEmptyProjectActions.map((action) => put(action)))
  } catch (error) {
    console.error('Error creating project boilerplate:', error)
  }
}
